var map = {
	"./AAVE.svg": 1343,
	"./ADA.svg": 3000,
	"./ADX.svg": 9952,
	"./AE.svg": 8631,
	"./AGIX.svg": 8777,
	"./ALGO.svg": 8772,
	"./ARDR.svg": 5890,
	"./ARK.svg": 9278,
	"./ATOM.svg": 1344,
	"./AVAX.svg": 7103,
	"./BAT.svg": 5446,
	"./BCC.svg": 2573,
	"./BCH.svg": 7130,
	"./BCN.svg": 7977,
	"./BLOCK.svg": 4759,
	"./BNB.svg": 5127,
	"./BNT.svg": 9983,
	"./BTC.svg": 7539,
	"./BTCD.svg": 641,
	"./BTG.svg": 8221,
	"./BTM.svg": 827,
	"./BTS.svg": 6463,
	"./CNX.svg": 7826,
	"./CRO.svg": 4500,
	"./CVC.svg": 490,
	"./DASH.svg": 1186,
	"./DCR.svg": 7215,
	"./DGB.svg": 8527,
	"./DGD.svg": 1539,
	"./DOGE.svg": 2662,
	"./DOT.svg": 1902,
	"./EDG.svg": 480,
	"./EMC2.svg": 3221,
	"./EOS.svg": 9870,
	"./ETC.svg": 5069,
	"./ETH.svg": 4079,
	"./ETHOS.svg": 3661,
	"./ETP.svg": 7899,
	"./FCT.svg": 6724,
	"./FET.svg": 5068,
	"./FIL.svg": 9310,
	"./FUN.svg": 85,
	"./GAME.svg": 6352,
	"./GAS.svg": 3935,
	"./GBYTE.svg": 9709,
	"./GNO.svg": 9492,
	"./GNT.svg": 6326,
	"./GRS.svg": 2233,
	"./GXS.svg": 5999,
	"./HSR.svg": 5808,
	"./ICN.svg": 1201,
	"./IMX.svg": 1917,
	"./IOT.svg": 6025,
	"./KMD.svg": 6414,
	"./KNC.svg": 5935,
	"./LINK.svg": 703,
	"./LSK.svg": 3485,
	"./LTC.svg": 2395,
	"./LUNA.svg": 7440,
	"./MAID.svg": 4402,
	"./MCO.svg": 8199,
	"./MNX.svg": 8463,
	"./MONA.svg": 9371,
	"./MTL.svg": 5998,
	"./NAV.svg": 7649,
	"./NEAR.svg": 1424,
	"./NEO.svg": 1856,
	"./NXS.svg": 4803,
	"./NXT.svg": 2862,
	"./OMG.svg": 395,
	"./PAY.svg": 6733,
	"./PEPE.svg": 8862,
	"./PIVX.svg": 2525,
	"./POT.svg": 7493,
	"./POWER.svg": 6625,
	"./PPC.svg": 7543,
	"./PPT.svg": 7735,
	"./PURA.svg": 7818,
	"./QASH.svg": 4124,
	"./QNT.svg": 863,
	"./QTUM.svg": 6901,
	"./RDN.svg": 3706,
	"./REP.svg": 8265,
	"./SALT.svg": 9919,
	"./SAN.svg": 775,
	"./SC.svg": 2243,
	"./SHIB.svg": 4325,
	"./SKY.svg": 9749,
	"./SNGLS.svg": 7217,
	"./SNT.svg": 7494,
	"./SOL.svg": 3397,
	"./START.svg": 5580,
	"./STEEM.svg": 1443,
	"./STORJ.svg": 574,
	"./SUSHI.svg": 3729,
	"./SYS.svg": 3477,
	"./THETA.svg": 9628,
	"./TRX.svg": 6746,
	"./UBQ.svg": 928,
	"./UNI.svg": 5001,
	"./USDC.svg": 594,
	"./USDT.svg": 5360,
	"./VEN.svg": 2533,
	"./VTC.svg": 383,
	"./WAVES.svg": 4785,
	"./WBTC.svg": 5290,
	"./WTC.svg": 7839,
	"./XEM.svg": 736,
	"./XLM.svg": 5837,
	"./XMR.svg": 9572,
	"./XRP.svg": 42,
	"./XTZ.svg": 4708,
	"./XUC.svg": 9128,
	"./XVG.svg": 3588,
	"./XZC.svg": 9716,
	"./ZEC.svg": 962,
	"./ZEN.svg": 1068,
	"./ZETA.svg": 6214,
	"./ZRX.svg": 4915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6151;